import { getAllSuborganizationCorpEntities } from "../../app/services/Suborganizations/getAllSuborganizationCorpEntities"
import { getAllSuborganizationCustomerSupportCorpEntities } from "../../app/services/Suborganizations/getAllSuborganizationCustomerSupportCorpEntities"
import { getAllSuborganizationGroupCorpEntity } from "../../app/services/Suborganizations/getAllSuborganizationGroupCorpEntity"
import { getAllSuborganizationStaffCorpEntities } from "../../app/services/Suborganizations/getAllSuborganizationStaffCorpEntities"
import { getSuborganizationCorpEntities } from "../../app/services/Suborganizations/getSuborganizationCorpEntities"
import { getSuborganizationTypeCorpEntities } from "../../app/services/Suborganizations/getSuborganizationTypeCorpEntities"
import { getUserSuborgDataCorpEntity } from "../../app/services/Suborganizations/getSupportedCustSuborgDataCorpEntity"
import { globalNotificationTypes } from "../constants/action-types"
import { setErrorTextSnackBar, setRequestTextSnackBar } from "./app"

// request get users of suborganizations
export const getAllUsersOfSuborganizations = (id) => {
  return async (dispatch) => {
    try {
      const response = await getAllSuborganizationStaffCorpEntities(id)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: StorageAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return []
    }
  }
}

// request get suborganizations
export const getSuborganizations = (id) => {
  return async (dispatch) => {
    try {
      const response = await getSuborganizationCorpEntities(id)

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: SuborganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

// request get suborganizations of organization with orgId
export const getAllSuborganizations = (id) => {
  return async (dispatch) => {
    try {
      const response = await getAllSuborganizationCorpEntities(id)

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: SuborganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
export const getAllCustomerSupport = (id) => {
  return async (dispatch) => {
    try {
      const response = await getAllSuborganizationCustomerSupportCorpEntities(
        id,
      )

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: SuborganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return []
    }
  }
}

// request get types of suborganization
export const getTypesSuborganizations = (id) => {
  return async (dispatch) => {
    try {
      const response = await getSuborganizationTypeCorpEntities(id)

      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: SuborganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const getUserClients = (id) => {
  return async (dispatch) => {
    try {
      const response = await getUserSuborgDataCorpEntity(id)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: SuborganizationAPI",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}

export const setErrorSuborganizationGroup = (error) => {
  return {
    type: globalNotificationTypes.SUBORG_GROUPS_FAILURE,
    payload: error,
  }
}
export const setSuccessSuborganizationGroup = (data) => {
  return {
    type: globalNotificationTypes.SUBORG_GROUPS_SUCCESS,
    payload: data,
  }
}
export const setRequestSuborganizationGroup = () => {
  return {
    type: globalNotificationTypes.SUBORG_GROUPS_REQUEST,
  }
}
// request get suborganizations groups from gloabl notifications
export const getAllSuborganizationGroup = () => {
  return async (dispatch) => {
    try {
      const response = await getAllSuborganizationGroupCorpEntity()
      dispatch(setSuccessSuborganizationGroup(response?.data?.data))
    } catch (error) {
      dispatch(setErrorSuborganizationGroup())
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en el servicio: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
